var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-container',[_c('el-aside',{staticClass:"common-style",attrs:{"width":"267px"}},[_c('RecruitHeader',{attrs:{"title":"职位类型"}}),_c('RecruitCategory')],1),_c('el-main',{staticClass:"common-style"},[_c('RecruitHeader',{attrs:{"title":"职位搜索"}}),_c('RecruitCategoryDetail')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }